/**
 * Allys Pagination
 * 
 * Enhanced pagination with Allys theme styling built-in
 */

'use client';

import { Pagination, type PaginationProps } from '@/components/ui/Pagination';

export type AllysPaginationProps = PaginationProps;

export function AllysPagination(props: AllysPaginationProps) {
  return <Pagination {...props} />;
}
